import { getFlagByCountryName, getFlagUrlByCountryName } from "./country-flags";

const paisesVisitados = (window.AtlasData && AtlasData.paisesVisitados) || {};
const paisesPontos = (window.AtlasData && AtlasData.paisesPontos) || {};
const paisesLinks = (window.AtlasData && AtlasData.paisesLinks) || {};
const corBaseMapa = "#ffffff";

function getNomePortugues(nomeIngles) {
	const mapa = {
		Brazil: "Brasil",
		Argentina: "Argentina",
		Uruguay: "Uruguai",
		Paraguay: "Paraguai",
		Bolivia: "Bolívia",
		Chile: "Chile",
		Peru: "Peru",
		Ecuador: "Equador",
		Colombia: "Colômbia",
		Venezuela: "Venezuela",
		Suriname: "Suriname",
		Guyana: "Guiana",
		"French Guiana": "Guiana Francesa",
		Mexico: "México",
		"United States of America": "Estados Unidos",
		"United States": "Estados Unidos",
		Canada: "Canadá",
		Spain: "Espanha",
		Portugal: "Portugal",
		Italy: "Itália",
		France: "França",
		Germany: "Alemanha",
		China: "China",
		Japan: "Japão",
		"South Korea": "Coreia do Sul",
		India: "Índia",
		Australia: "Austrália",
		"United Kingdom": "Reino Unido",
		Netherlands: "Países Baixos",
		Belgium: "Bélgica",
		Switzerland: "Suíça",
		Austria: "Áustria",
		Poland: "Polônia",
		Czechia: "República Tcheca",
		Greece: "Grécia",
		Turkey: "Turquia",
		Russia: "Rússia",
		Ukraine: "Ucrânia",
		Egypt: "Egito",
		Morocco: "Marrocos",
		Tunisia: "Tunísia",
		Algeria: "Argélia",
		"Saudi Arabia": "Arábia Saudita",
		"United Arab Emirates": "Emirados Árabes Unidos",
		Qatar: "Catar",
		Kuwait: "Kuwait",
		Jordan: "Jordânia",
		Lebanon: "Líbano",
		Syria: "Síria",
		Iraq: "Iraque",
		Iran: "Irã",
		Palestine: "Palestina",
		Israel: "Israel",
		Oman: "Oman",
		Yemen: "Iêmen",
		"New Zealand": "Nova Zelândia",
		Fiji: "Fiji",
		"Papua New Guinea": "Papua-Nova Guiné",
		Indonesia: "Indonésia",
		Philippines: "Filipinas",
		Thailand: "Tailândia",
		Vietnam: "Vietnã",
		Malaysia: "Malásia",
		Singapore: "Singapura",
		Cambodia: "Camboja",
		Laos: "Laos",
		Myanmar: "Mianmar",
		Brunei: "Brunei",
		"Timor-Leste": "Timor-Leste",
		Iceland: "Islândia",
		Norway: "Noruega",
		Denmark: "Dinamarca",
		Sweden: "Suecia",
		Finland: "Finlândia",
		Ireland: "Irlanda",
		Scotland: "Escócia",
		Wales: "País de Gales",
		Hungary: "Hungria",
		Romania: "Romênia",
		Bulgaria: "Bulgária",
		Serbia: "Sérvia",
		Croatia: "Croácia",
		Slovenia: "Eslovênia",
		Slovakia: "Eslováquia",
		Lithuania: "Lituânia",
		Latvia: "Letônia",
		Estonia: "Estônia",
		"Bosnia and Herzegovina": "Bosnia e Herzegovina",
		Montenegro: "Montenegro",
		Kosovo: "Kosovo",
		"North Macedonia": "Macedônia do Norte",
		Albania: "Albania",
		Gibraltar: "Gibraltar",
		Malta: "Malta",
		Cyprus: "Chipre",
		Belarus: "Bielorrússia",
		Moldova: "Moldova",
		Afghanistan: "Afeganistão",
		Pakistan: "Paquistão",
		Bangladesh: "Bangladesh",
		"Sri Lanka": "Sri Lanka",
		Nepal: "Nepal",
		Bhutan: "Butão",
		Maldives: "Maldivas",
		Tajikistan: "Tajiquistão",
		Kyrgyzstan: "Quirguistão",
		Uzbekistan: "Uzbequistão",
		Turkmenistan: "Turcomenistão",
		Mongolia: "Mongólia",
		"North Korea": "Coreia do Norte",
		Cuba: "Cuba",
		Haiti: "Haiti",
		"Dominican Republic": "República Dominicana",
		Jamaica: "Jamaica",
		"Trinidad and Tobago": "Trindade e Tobago",
		Bahamas: "Bahamas",
		Barbados: "Barbados",
		Grenada: "Granada",
		"Saint Lucia": "Santa Lucia",
		"Saint Vincent and the Grenadines": "São Vicente e Granadinas",
		"Antigua and Barbuda": "Antígua e Barbuda",
		Dominica: "Dominica",
		"Saint Kitts and Nevis": "São Cristóvão e Nevis",
		Ethiopia: "Etiópia",
		Kenya: "Quênia",
		Uganda: "Uganda",
		Rwanda: "Ruanda",
		Burundi: "Burundi",
		Tanzania: "Tanzania",
		Zambia: "Zambia",
		Zimbabwe: "Zimbabwe",
		Malawi: "Malawi",
		Botswana: "Botswana",
		Namibia: "Namíbia",
		Lesotho: "Lesotho",
		Swaziland: "Suazilandia",
	};
	return mapa[nomeIngles] || nomeIngles;
}

document.addEventListener("DOMContentLoaded", () => {
	const container = d3.select("#atlas-map");
	if (container.empty()) return;

	const svg = container.append("svg").attr("class", "w-full h-full block");
	const projection = d3.geoNaturalEarth1();
	const path = d3.geoPath().projection(projection);
	const ALL_CITIES_VALUE = "__all__";
	const cityFilterRoot = document.getElementById("atlas-city-filter");
	const cityFilterTrigger = document.getElementById("atlas-city-filter-trigger");
	const cityFilterLabel = document.getElementById("atlas-city-filter-label");
	const cityFilterPanel = document.getElementById("atlas-city-filter-panel");
	const cityFilterSearch = document.getElementById("atlas-city-filter-search");
	const cityFilterOptions = document.getElementById("atlas-city-filter-options");
	let activeCityFilter = ALL_CITIES_VALUE;
	let markerRegistry = [];
	let cityOptionsData = [];

	const getCityNameFromPoint = (pt, pais) => {
		const raw = (pt && pt.label ? String(pt.label) : "").trim();
		return raw || pais;
	};

	const normalizeCityValue = (city) =>
		city
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/(^-|-$)/g, "");

	const applyCityFilter = () => {
		if (!markerRegistry.length) return;

		markerRegistry.forEach((entry) => {
			const isVisible =
				activeCityFilter === ALL_CITIES_VALUE ||
				entry.cityValue === activeCityFilter;

			entry.marker.style("display", isVisible ? null : "none");
		});
	};

	const getCountryOptionColor = (country) => {
		const key = normalizeCityValue(country || "pais");
		let hash = 0;
		for (let i = 0; i < key.length; i += 1) {
			hash = key.charCodeAt(i) + ((hash << 5) - hash);
		}
		const hue = Math.abs(hash) % 360;
		return `hsla(${hue} 70% 72% / 0.35)`;
	};

	const closeCityFilterPanel = () => {
		if (!cityFilterPanel || !cityFilterTrigger) return;
		cityFilterPanel.classList.add("hidden");
		cityFilterTrigger.setAttribute("aria-expanded", "false");
	};

	const openCityFilterPanel = () => {
		if (!cityFilterPanel || !cityFilterTrigger) return;
		cityFilterPanel.classList.remove("hidden");
		cityFilterTrigger.setAttribute("aria-expanded", "true");
		if (cityFilterSearch) {
			cityFilterSearch.focus();
		}
	};

	const updateCityFilterLabel = () => {
		if (!cityFilterLabel) return;
		const selected = cityOptionsData.find((option) => option.value === activeCityFilter);
		cityFilterLabel.textContent = selected ? selected.label : "Mostrar todas";
	};

	const renderCityFilterOptions = (query = "") => {
		if (!cityFilterOptions) return;
		const normalizedQuery = normalizeCityValue(query || "");
		cityFilterOptions.innerHTML = "";

		const filtered = cityOptionsData.filter((option) => {
			if (!normalizedQuery) return true;
			return normalizeCityValue(option.label).includes(normalizedQuery);
		});

		if (!filtered.length) {
			const empty = document.createElement("li");
			empty.className = "atlas-city-filter-option atlas-city-filter-option-empty";
			empty.textContent = "Nenhuma cidade encontrada";
			cityFilterOptions.appendChild(empty);
			return;
		}

		filtered.forEach((option) => {
			const item = document.createElement("li");
			item.className = "atlas-city-filter-option";
			item.dataset.value = option.value;
			item.style.background = option.background;
			if (option.value === activeCityFilter) {
				item.classList.add("is-active");
			}

			item.innerHTML = `<span class="atlas-city-filter-flag">${option.flag}</span><span class="atlas-city-filter-text">${option.label}</span>`;
			item.addEventListener("click", () => {
				activeCityFilter = option.value;
				updateCityFilterLabel();
				applyCityFilter();
				closeCityFilterPanel();
			});
			cityFilterOptions.appendChild(item);
		});
	};

	const setupCityFilter = () => {
		if (!cityFilterRoot || !cityFilterTrigger || !cityFilterOptions) return;

		cityFilterTrigger.addEventListener("click", () => {
			const isOpen = !cityFilterPanel.classList.contains("hidden");
			if (isOpen) {
				closeCityFilterPanel();
			} else {
				openCityFilterPanel();
				renderCityFilterOptions(cityFilterSearch ? cityFilterSearch.value : "");
			}
		});

		if (cityFilterSearch) {
			cityFilterSearch.addEventListener("input", (event) => {
				renderCityFilterOptions(event.target.value);
			});
		}

		document.addEventListener("click", (event) => {
			if (!cityFilterRoot.contains(event.target)) {
				closeCityFilterPanel();
			}
		});
	};

	const populateCityFilterOptions = () => {
		if (!cityFilterRoot || !cityFilterOptions) return;

		const optionMap = new Map();
		Object.entries(paisesPontos).forEach(([pais, pontos]) => {
			if (!paisesVisitados[pais]) return;
			(pontos || []).forEach((pt) => {
				const cityName = getCityNameFromPoint(pt, pais);
				const cityValue = normalizeCityValue(cityName);
				if (!cityValue || optionMap.has(cityValue)) return;
				optionMap.set(cityValue, {
					cityName,
					countryName: pais,
				});
			});
		});

		cityOptionsData = [
			{
				value: ALL_CITIES_VALUE,
				label: "Mostrar todas",
				flag: "📍",
				background: "rgba(255, 255, 255, 0.2)",
			},
			...Array.from(optionMap.entries())
				.sort((a, b) => a[1].cityName.localeCompare(b[1].cityName, "pt-BR"))
				.map(([value, info]) => ({
					value,
					label: info.cityName,
					flag: getFlagByCountryName(info.countryName) || "📍",
					background: getCountryOptionColor(info.countryName),
				})),
		];

		updateCityFilterLabel();
		renderCityFilterOptions();
	};

	const tooltip = d3
		.select("body")
		.append("div")
		.attr("class", "country-tooltip")
		.style("position", "absolute")
		.style("background", "#000")
		.style("padding", "8px 12px")
		.style("border-radius", "6px")
		.style("box-shadow", "0 0 2px 2px #fff")
		.style("font-size", "14px")
		.style("color", "#fff")
		.style("pointer-events", "none")
		.style("opacity", 0)
		.style("z-index", "1000")
		.style("white-space", "nowrap");

	d3.json(
		"https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json",
	).then((worldData) => {
		populateCityFilterOptions();
		setupCityFilter();

		const countries = topojson.feature(
			worldData,
			worldData.objects.countries,
		).features;

		const countryPaths = svg
			.selectAll("path")
			.data(countries)
			.enter()
			.append("path")
			.attr("stroke", "#fff")
			.attr("stroke-width", 0.2)
			.attr("data-pais", (d) => getNomePortugues(d.properties.name))
			.on("mouseover", function (event, d) {
				const nomePt = getNomePortugues(d.properties.name);
				if (!paisesVisitados[nomePt]) return;

				d3.select(this)
					.transition()
					.duration(150)
					.attr("fill", corBaseMapa)
					.attr("stroke-width", 1)
					.attr("stroke", "#000")
					.style("cursor", "pointer");

				tooltip.style("opacity", 1).html(`<strong>${nomePt}</strong>`);
			})
			.on("mousemove", function (event) {
				tooltip
					.style("left", event.pageX + 10 + "px")
					.style("top", event.pageY - 28 + "px");
			})
			.on("mouseout", function (event, d) {
				const nomePt = getNomePortugues(d.properties.name);
				d3.select(this)
					.transition()
					.duration(150)
					.attr("fill", corBaseMapa)
					.attr("stroke-width", 0.2)
					.attr("stroke", "#fff");

				tooltip.style("opacity", 0);
			})
			.on("click", function (event, d) {
				const nomePt = getNomePortugues(d.properties.name);
				const url = paisesLinks[nomePt] || paisesLinks[d.properties.name] || "";
				if (url) window.open(url, "_blank");
			});

		function renderMap() {
			const width = container.node().clientWidth;
			const height = container.node().clientHeight;

			svg.attr("viewBox", `0 0 ${width} ${height}`);
			const offsetX = width >= 1024 ? width * 0.05 : 0;
			projection
				.scale(width / 6.2)
				.translate([width / 2 - offsetX, height / 2]);

			countryPaths.attr("d", path).attr("fill", corBaseMapa);

			// Remove marcadores anteriores
			svg.selectAll(".country-marker").remove();
			markerRegistry = [];

			Object.entries(paisesPontos).forEach(([pais, pontos]) => {
				if (!paisesVisitados[pais]) return;
				pontos.forEach((pt) => {
					const lat = parseFloat(pt.lat);
					const lon = parseFloat(pt.lon);
					const label = pt.label || "";
					const link = pt.link || "";
					if (isNaN(lat) || isNaN(lon)) return;

					const [x, y] = projection([lon, lat]);
					const flagUrl = getFlagUrlByCountryName(pais);
					if (!flagUrl) return;
					const cityName = getCityNameFromPoint(pt, pais);
					const cityValue = normalizeCityValue(cityName);

					const poleHeight = width < 640 ? 9 : width < 1024 ? 12 : 16;
					const flagSize = width < 640 ? 9 : width < 1024 ? 12 : 16;

					const marcador = svg
						.append("g")
						.attr("class", "country-marker")
						.attr("transform", `translate(${x}, ${y})`)
						.style("cursor", link ? "pointer" : "default")
						.style("pointer-events", "all");

					marcador
						.append("rect")
						.attr("x", 0)
						.attr("y", -poleHeight)
						.attr("width", 2)
						.attr("height", poleHeight)
						.attr("rx", 1)
						.attr("fill", "#cecece");

					marcador
						.append("circle")
						.attr("cx", 1)
						.attr("cy", -poleHeight)
						.attr("r", 2)
						.attr("fill", "#cecece");

					marcador
						.append("image")
						.attr("href", flagUrl)
						.attr("width", flagSize)
						.attr("height", flagSize)
						.attr("x", 2)
						.attr("y", -20)
						.attr("preserveAspectRatio", "xMidYMid meet");

					marcador
						.on("mouseover", function () {
							d3.select(this)
								.transition()
								.duration(150)
								.attr("transform", `translate(${x}, ${y}) scale(1.2)`)
								.style("filter", "drop-shadow(0 6px 8px rgba(0,0,0,0.35))")
								.style("z-index", 10);
							// Destaca o país correspondente
							svg.selectAll(`path[data-pais="${pais}"]`)
								.transition()
								.duration(150)
								.attr("stroke-width", 1)
								.attr("stroke", "#000");

							let tooltipContent = `<strong>${label || pais}</strong>`;
							if (link) {
								tooltipContent += `<br><span style="font-size: 12px; opacity: 0.8;">🔗 Clique para abrir</span>`;
							}
							tooltip.style("opacity", 1).html(tooltipContent);
						})
						.on("mousemove", function (event) {
							tooltip
								.style("left", event.pageX + 10 + "px")
								.style("top", event.pageY - 28 + "px");
						})
						.on("mouseout", function () {
							d3.select(this)
								.transition()
								.duration(150)
								.attr("transform", `translate(${x}, ${y})`)
								.style("filter", null);

							// Remove destaque do país
							svg.selectAll(`path[data-pais="${pais}"]`)
								.transition()
								.duration(150)
								.attr("stroke-width", 0.2)
								.attr("stroke", "#fff");

							tooltip.style("opacity", 0);
						});

					if (link) {
						marcador.on("click", () => window.open(link, "_blank"));
					}

					markerRegistry.push({
						cityValue,
						marker: marcador,
					});
				});
			});

			applyCityFilter();
		}

		renderMap();
		window.addEventListener("resize", renderMap);
	});
});
